var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27273 0.680664C4.5124 0.680664 1.30107 3.00845 0 6.2943C1.30107 9.58015 4.5124 11.9079 8.27273 11.9079C12.0331 11.9079 15.2444 9.58015 16.5455 6.2943C15.2444 3.00845 12.0331 0.680664 8.27273 0.680664ZM8.27273 10.0367C6.19703 10.0367 4.5124 8.36012 4.5124 6.2943C4.5124 4.22848 6.19703 2.55188 8.27273 2.55188C10.3484 2.55188 12.0331 4.22848 12.0331 6.2943C12.0331 8.36012 10.3484 10.0367 8.27273 10.0367ZM8.27273 4.04885C7.0243 4.04885 6.01653 5.05182 6.01653 6.2943C6.01653 7.53679 7.0243 8.53976 8.27273 8.53976C9.52116 8.53976 10.5289 7.53679 10.5289 6.2943C10.5289 5.05182 9.52116 4.04885 8.27273 4.04885Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dac4e23f9580d5ac5d8c67d1d55498ff.svg";
export { ForwardRef as ReactComponent };